export class OTPVerificationRequest {
    email: string;
    otp: string;
}
